export default __webpack_public_path__ + "static/media/pids.7dc4980b.jpg";